// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"ce756347","384":"fcb2af79","621":"08f3d3ba","766":"61ef7c53","806":"fb36f863","908":"7a0f5ba6"}[chunkId] + ".chunk.js";
};